import Loading from 'flow/components/ui-components/Loading';
import useProfiles from 'flow/hooks/useProfiles';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { useHistory, useParams } from 'react-router-dom';
import { generatePath } from 'flow/utils/router-utils';
import AvailableLandline from './Pages/AvailableLandline';
import Busy from './Pages/Busy';
import Delay from './Pages/Delay';
import Disconnect from './Pages/Disconnect';
import Mobile from './Pages/Mobile';
import MultipleLandline from './Pages/MultipleLandline';
import OtherLandline from './Pages/OtherLandline';

interface Params {
    extensionKey: ExtensionKey;
    profileKey: string;
    settingType: 'landline' | 'mobile' | 'busy' | 'delay' | 'disconnected';
}

const IncomingCallsProfileSettingPage = () => {
    const history = useHistory();
    const { extensionKey, profileKey, settingType } = useParams<Params>();
    const { profiles, getProfile } = useProfiles(extensionKey);

    if (!profiles) return <Loading />;

    const findProfile = () =>
        getProfile(profileKey) ||
        (profileKey === 'profile' &&
            profiles.find((profile) => profile.get('plusId') === 1));

    const profile = findProfile();

    const handleBackClick = () => {
        if (profile?.get('available') || profileKey === 'profile') {
            history.push(
                generatePath(routes['settings.incoming-calls'], {
                    extensionKey,
                }),
            );
        } else {
            history.push(
                generatePath(routes['settings.incoming-calls.profileKey'], {
                    extensionKey,
                    profileKey,
                }),
            );
        }
    };

    if (!profile) return null;

    switch (settingType) {
        case 'landline':
            if (profileKey === 'profile') {
                return (
                    <MultipleLandline
                        profiles={profiles}
                        onClickBack={handleBackClick}
                    />
                );
            }

            if (profile?.get('plusId') === 0) {
                return (
                    <AvailableLandline
                        profile={profile}
                        onClickBack={handleBackClick}
                    />
                );
            }

            return (
                <OtherLandline
                    profile={profile}
                    onClickBack={handleBackClick}
                />
            );

        case 'mobile':
            return <Mobile profile={profile} onClickBack={handleBackClick} />;
        case 'busy':
            return <Busy profile={profile} onClickBack={handleBackClick} />;
        case 'delay':
            return <Delay profile={profile} onClickBack={handleBackClick} />;
        case 'disconnected':
            return (
                <Disconnect profile={profile} onClickBack={handleBackClick} />
            );
        default:
            history.push(
                generatePath(routes['settings.incoming-calls'], {
                    extensionKey,
                }),
            );
            return null;
    }
};

export default IncomingCallsProfileSettingPage;
